<template>

  <v-container>
  <v-layout>
      <v-flex xs12>
        <template>
            <div class="loading-parent">
                <loading :active.sync="showloader" 
                :can-cancel="false" 
                :is-full-page="true"></loading>
            </div>
        </template>
     </v-flex>


  </v-layout>
  </v-container>
</template>

<script>
    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.min.css';


  export default {
    components:{
      Loading
    },
    data () {
      return {
        showloader:false,
        redirectpage: null
      }
    },    
    created (){   
        console.log('RouteForwarder.vue - ')   
      this.redirectpage = this.getUrlVars()['r']
      console.log('RouteForwarder.vue - redirectpage ' + this.redirectpage)
     
    },
    computed: {
      memberStatusDetermined () {
        return this.$store.getters.memberStatusDetermined
      }, 
      member () {
        return this.$store.getters.member
      }, 
      user () {
        return this.$store.getters.user
      },
      loading () {
        return this.$store.getters.loading
      }
    },
    watch: {
      memberStatusDetermined (value){
        
        if(value===false){
          this.showloader=true
        }else{
          this.showloader=false

        }
        
      },
      member (value) {
        if (value !== null && value !== undefined) {
            console.log('pushingrouter to  /' + this.redirectpage + ' from RouteForwarder.vue (member watch)')
            this.$router.push('/' + this.redirectpage)
        }
      }
   

    },
    methods: {
        getUrlVars: function(name) {
            var vars = {};
            var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
                vars[key] = value;
            });
            return vars;
        }

    }

  }
</script>

<style>
#postFieldList .v-subheader{
    width:110px;
    padding-left: 0px;
    background-color: ghostwhite;
    margin-right: 8px;
}

#postComments .v-card{
    background-color:blue;
}
#fieldContainer .v-card__text{
    padding:5px;
}
.fieldlabel, .fieldlabel .v-card{
    background-color: ghostwhite;
    text-align: left;
}

.convo-card{
  border-radius:15px;
 
}


.chat-card{
  border-radius:15px;
  padding-left:10px;
  margin-right:10px;  
  
}

.chat-card-me{
  border-radius:15px;
  padding-left:10px;
  margin-right:10px;  
  
}

.chat-card-date{
    text-align: right;
    margin-right:15px;
    color:dimgrey;
}

.btn-no{
  background-color: #ff5252 !important;
}

.btn-yes{
  background-color: #4caf50 !important;
}
</style>